// FILE: client/src/screens/ProductScreenEntry.js

import React, { useEffect, useState } from "react";
import ProductScreen from "../product/ProductScreen";
import ProductScreenMobile from "../product/ProductScreenMobile";
/**
 * ProductScreenEntry
 * Renders desktop ProductScreen OR ProductScreenMobile
 * based on viewport width.
 *
 * Usage:
 *   <ProductScreenEntry />
 */
export default function ProductScreenEntry({ breakpoint = 991.98 }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const handleChange = (event) => {
      setIsMobile(event.matches);
    };

    setIsMobile(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, [breakpoint]);

  if (isMobile) {
    return <ProductScreenMobile />;
  }

  return <ProductScreen />;
}